export const LOQATE_API_KEY = import.meta.env.VITE_LOQATE_API_KEY;
export const BRAINTREE_AUTHORIZATION = import.meta.env
  .VITE_BRAINTREE_AUTHORIZATION;
export const API_HOST = import.meta.env.VITE_API_HOST;
export const GOOGLE_MERCHANT_ID = import.meta.env.VITE_GOOGLE_MERCHANT_ID;
export const ORGANIZATION_NAME =
  import.meta.env.VITE_ORGANIZATION_NAME ?? "-- ORGANIZATION NAME --";
export const USE_QUERY_PARAM_ALIAS =
  import.meta.env.VITE_USE_QUERY_PARAM_ALIAS === "true";
export const USE_STATIC_CONFIG =
  import.meta.env.VITE_USE_STATIC_CONFIG === "true";
export const IS_DEVELOPMENT = import.meta.env.DEV;
export const IS_PRODUCTION = import.meta.env.PROD;
export const IS_TEST = import.meta.env.TEST;

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_TRACE_TARGETS = API_HOST
  ? [new RegExp(`^${API_HOST.replace(/\./g, "\\.")}`)]
  : [];

export const ASSETS_PATH = window.__ASSETS_PATH__ || "/";
export const PAYMENT_ENVIRONMENT =
  import.meta.env.VITE_PAYMENT_ENVIRONMENT || "TEST";

export const CURRENCY = "GBP";
export const PAYMENT_ERROR_CODE = 2044;
